import { Box, Grid2, Typography } from "@mui/material";
import { SUMMARY_TILE_TONES, TRUCK_STATUS_LABELS } from "../../../../constants";
import { TruckStatus } from "../../../../enums";
import { SummaryTileTone, Truck } from "../../../../types";

type SummaryCardProps = {
  label: string;
  value: number;
  helperText: string;
  tone: SummaryTileTone;
};

const SummaryCard = ({ label, value, helperText, tone }: SummaryCardProps) => (
  <Box
    className="dashboard-tile"
    sx={{
      minHeight: "auto",
      py: 1.5,
      backgroundColor: SUMMARY_TILE_TONES[tone].background,
      borderColor: SUMMARY_TILE_TONES[tone].border,
    }}
  >
    <Typography className="dashboard-metric-label">{label}</Typography>
    <Typography
      className="dashboard-kpi-value"
      sx={{ mt: 0.5, color: SUMMARY_TILE_TONES[tone].value }}
    >
      {value}
    </Typography>
    <Typography className="dashboard-helper-text" sx={{ mt: 0.5 }}>
      {helperText}
    </Typography>
  </Box>
);

type TruckSummaryCardsProps = {
  trucks: Truck[];
};

export const TruckSummaryCards = ({ trucks }: TruckSummaryCardsProps) => {
  const countByStatus = (status: TruckStatus) =>
    trucks.filter((truck) => truck.status === status).length;
  const helperText = `of ${trucks.length} trucks`;

  const cards: SummaryCardProps[] = [
    {
      label: TRUCK_STATUS_LABELS[TruckStatus.Active],
      value: countByStatus(TruckStatus.Active),
      helperText,
      tone: "success",
    },
    {
      label: TRUCK_STATUS_LABELS[TruckStatus.Available],
      value: countByStatus(TruckStatus.Available),
      helperText,
      tone: "info",
    },
    {
      label: TRUCK_STATUS_LABELS[TruckStatus.InMaintenance],
      value: countByStatus(TruckStatus.InMaintenance),
      helperText,
      tone: "warning",
    },
    {
      label: TRUCK_STATUS_LABELS[TruckStatus.OutOfService],
      value: countByStatus(TruckStatus.OutOfService),
      helperText,
      tone: "danger",
    },
  ];

  return (
    <Grid2 container spacing={2}>
      {cards.map((card) => (
        <Grid2 key={card.label} size={{ xs: 12, md: 6, lg: 3 }}>
          <SummaryCard {...card} />
        </Grid2>
      ))}
    </Grid2>
  );
};
